<template>
    <div id="results-container" class="grid-results">
        <div v-if="items.length === 0" class="no-results">Ничего не найдено</div>

        <ResultItem v-for="item in items" :key="item.id" :item="item" />
    </div>
</template>

<script>
    import ResultItem from './ResultItem.vue'

    export default {
        components: { ResultItem },
        props: {
            items: {
                type: Array,
                default: () => []
            }
        }
    }
</script>
